export enum CorrectiveMaintenancePriority {
  Ordinary = 0,
  Blocking = 1,
  Urgent = 2,
}
